import React, { useState } from "react";
import { AvField, AvForm } from "availity-reactstrap-validation"
import Select from "react-select";
import { Row, Col, Label } from 'reactstrap'
import ShapeImgModal from "../ShapeImgModal"

const shapes = [
    { value: 'Circle', label: 'Circle' },
    { value: 'Rect', label: 'Rect' },
    { value: 'Cubic', label: 'Cubic' },
    { value: 'node', label: 'node' },
    { value: 'Pin', label: 'Pin' },
    { value: 'Arrow', label: 'Arrow' },
    { value: 'Build', label: 'Build' }
]
const ShapeBuilding = ({
    addBuilding,
    buildingErrors,
    setAddBuildingStatus
}) => {
    const [data, setData] = useState({
        hotspot: {
            label: 'Building',
            value: 'addBuilding',
            type: 'building'
        },
        selectedShape: "",
        opacity: 1,
        fill: '#fd3d3d'
    })
    const [shapeImgModal, setShapeImgModal] = useState(false)

    return (
        <>
            <Row className="mb-4">
                <Col sm={12} md={1} className="m-0 px-0 d-flex align-items-center ">
                    <div className="d-flex">
                        <input
                            className="mt-4 mx-1"
                            type="radio" 
                            id={`next`} 
                            name="next"
                            checked={true}
                            style={{ width: '17px', height: '17px', accentColor: 'green' }}
                            onChange={()=> {}}
                        />
                        <input
                            className="mt-4 mx-1"
                            type="checkbox"
                            name="highlight-checkbox"
                            checked={data?.highlight}
                            onChange={e=> {
                                setData({...data, highlight: e.target.checked})
                            }}
                        />
                    </div>
                    <div className="mt-0 ms-2">
                        <Label>Photo</Label>
                        {data?.idImage?.path ? <img
                            style={{ height: "40px", width: "40px", objectFit: "cover", overflow: "hidden", borderRadius: "8px" }}
                            src={data?.idImage?.path} 
                            onClick={() => { 
                                setShapeImgModal(true)
                            }}
                            />
                            : <div className="m-0 p-1 bg-light" style={{ borderRadius:"8px"}} >
                            <button type="button" className=" px-1 py-0  btn-upload  font-size-18 font-weight-bold"
                                style={{ height: "30px", width: "30px" ,background:"none",border: "1px #cadff7 dashed", borderRadius:"8px" }}
                                onClick={() => {  
                                    setShapeImgModal(true)
                                }} >
                                    +</button>
                            </div>
                         }
                    </div>
                </Col>
                <Col sm={12} md={(data?.selectedShape?.value == 'node' || data?.selectedShape?.value =='Cubic') ? 2 : 3} style={{paddingLeft: '22px'}}>
                    <AvForm className="position-relative">
                        <label className={`${(buildingErrors[data.title]) ? "error-text" : ''}`}>Title</label>
                        <AvField
                            name='ar'
                            className={`form-control ${(buildingErrors[data.title]) ? "error-text" : ''}`}
                            placeholder={!data?.selectedShape ? "Select Shape Type First" : "Phase Name"}
                            style={{borderColor: `${(buildingErrors[data.title]) ? "#f46a6a" : '#ced4da'}`}}
                            bsSize="lg"
                            value={data?.title}
                            onChange= {(e)=> {
                                setData({...data, title: e.target.value})
                            }}
                            onBlur={()=> {
                                addBuilding(data)
                            }}
                            disabled={!data?.selectedShape}
                        />
                        {(buildingErrors[data.title]) && <p className="error-text font-size-11 m-0 position-absolute">{!!data?.title ? 'Building Already Exist' : 'Title are Required'}</p>}
                    </AvForm>
                </Col>
                {(data?.selectedShape?.value == 'node' || data?.selectedShape?.value =='Cubic') && <Col sm={12} md={1} className='p-0'>
                    <div className="position-relative d-flex" style={{gap: '8px'}}>
                        <div style={{display: 'table-caption'}}>
                            <label>Color</label>
                            <input 
                                type='color' 
                                className="mt-2"
                                style={{width: '30px'}}
                                value={data?.fill} 
                                onChange={(e)=> setData({...data, fill: e.target.value})} />
                        </div> 
                        <div style={{display: 'table-caption'}}>
                            <label>Opacity</label>
                            <input 
                                type='range' 
                                className="mt-3"
                                style={{width: '50px'}}
                                value={data?.opacity} 
                                min={0.2} max={1} step={.1}
                                onChange={(e)=> setData({...data, opacity: e.target.value})} />
                        </div>
                    </div>
                </Col>}
                <Col sm={12} md={3}>
                    <div>
                        <label>Shape Type</label>
                        <Select
                            placeholder='Select'
                            options={shapes}
                            onChange={(e) => setData({...data, selectedShape: e})}
                            value={data?.selectedShape}
                        />
                    </div>
                </Col>
                <Col sm={12} md={3}>
                    <label>Hotspot Type</label>
                    <Select
                        placeholder='Select'
                        options={[]}
                        onChange={(e)=> {}}
                        value={data?.hotspot}
                    />
                </Col>

                <Col sm={12} md={1}>
                <Label>Action</Label>
                    <button style={{fontSize:"0.92rem"}} 
                        className="btn btn-white border-light border-2 py-2 px-3" 
                        onClick={() => setAddBuildingStatus(false)}
                    >Cancel</button>
                </Col>
            </Row>

            {shapeImgModal && 
                <ShapeImgModal 
                    hotspot={data.hotspot} 
                    image={data?.idImage} 
                    modal={shapeImgModal} 
                    toggle={() => setShapeImgModal(false)} 
                    addShapeImgHandler={(index, img)=> setData({...data, idImage: img})} 
                    index={0} />
            }
        </>
    )
}

export default ShapeBuilding